import Box from '@mui/material/Box'

const SetDefault = () => (
  <Box
    component='svg'
    height={20}
    viewBox='0 0 21.4 20.13'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    sx={(theme) => ({
      '& .set-default-fill': { fill: '#888' },
      '& .set-default-outline': {
        fill: 'none',
        stroke: '#888',
        strokeMiterlimit: 10,
        strokeWidth: 1.5
      },
      '&:hover .set-default-fill': { fill: theme.palette.primary.accent },
      '&:hover .set-default-outline': { stroke: theme.palette.primary.accent }
    })}
  >
    <g id='a' />
    <g id='b'>
      <g id='c'>
        <path className='set-default-fill' id='d' d='M19.02,7.52l-2.45,6.28,2.42-1.48,2.41,1.51-2.39-6.31Z' />
      </g>
      <g id='e'>
        <path className='set-default-fill' d='M15.46,12.98c.04-.06,0-.1-.04-.14-.24-.21-.47-.43-.7-.64-.03-.03-.1-.05-.08-.12,.02-.04,.04-.09,.06-.13,.03-.08,.3-.76,.34-1.57-.02-.04,0-.08,0-.12,.04-.05,.09-.08,.14-.09,.07-.02,.85-.25,.85-.25,.15-.01,.17-.11,.14-.23l-.02-.14c-.02-.14-.05-.28-.07-.42l-.02-.14c-.02-.14-.05-.28-.07-.42l-.02-.14c0-.16-.1-.2-.24-.17l-.66,.03c-.33,.02-.33,0-.46-.31,0-.01-.33-.63-.82-1.16-.1-.09-.1-.18-.02-.28,0-.04,.43-.82,.46-.86,.03-.06,0-.09-.05-.12-.4-.28-.8-.56-1.2-.84-.06-.04-.1-.04-.14,0-.05,.02-.64,.7-.64,.7-.06,.13-.15,.16-.28,.09-.5-.17-.97-.3-1.52-.38-.14,0-.19-.07-.2-.19-.01-.06-.22-.69-.28-.78-.05-.14-.08-.22-.24-.16,0,0-1.3,.22-1.3,.22-.16,0-.15,.12-.14,.23-.02,.05,.03,.79,.03,.79,0,.09,.06,.18-.02,.26-.05,0-1.4,.85-1.47,.9-.07,.05-.15,.05-.22,0,0,0-.63-.29-.87-.42-.07-.04-.13-.05-.17,.03,0,0-.77,1.09-.8,1.13-.08,.1-.08,.17,.03,.25,.02,.01,.63,.61,.76,.74l-.03,.08s-.04,.1-.07,.21c-.01,.01-.04,.11-.07,.24-.06,.22-.13,.51-.17,.83-.03,.19-.06,.34-.05,.35,0,.03,0,.05-.02,.08-.03,.03-.07,.06-.11,.07-.07,.02-.85,.25-.85,.25-.07,0-.1,.03-.12,.06-.04,.01-.08,.03-.07,.09-.03,.05,.16,1.06,.25,1.42l.03-.05c.01,.14,.1,.18,.23,.15l.66-.03c.33-.02,.33,0,.46,.31,0,.01,.33,.63,.82,1.16,.1,.09,.1,.18,.02,.28,0,.04-.43,.82-.46,.86-.03,.06,0,.09,.05,.12,.4,.28,.8,.56,1.2,.84,.06,.04,.1,.04,.14,0,.05-.02,.64-.7,.64-.7,.06-.13,.15-.16,.28-.09,.5,.17,.97,.3,1.52,.38,.14,0,.19,.07,.2,.19,.01,.06,.22,.69,.28,.78,.04,.12,.08,.2,.19,.17h0c.39-.03,1.39-.21,1.43-.22,0,0,0-.02,.01-.03,.07-.04,.07-.12,.06-.21,.02-.05-.03-.79-.03-.79,0-.06-.02-.12,0-.18,.03-.02,.06-.03,.13-.05,.34-.13,.7-.37,.8-.43,.03-.02,.58-.45,.65-.51,.02-.04,.05-.02,.07,0,.24,.13,.83,.44,.83,.44,.14,.07,.22,.09,.3-.06,.02-.05,.75-1.1,.8-1.13Zm-7.22-.32c-1.44-1.01-1.79-2.99-.78-4.43,1.01-1.44,2.99-1.79,4.43-.78,1.44,1.01,1.79,2.99,.78,4.43-1.01,1.44-2.99,1.79-4.43,.78Z' />
        <g>
          <path className='set-default-outline' d='M19.17,12.03c-.38,1.77-1.28,3.45-2.69,4.79-3.73,3.54-9.63,3.39-13.17-.34C-.23,12.75-.08,6.86,3.65,3.31,7.38-.23,13.28-.08,16.82,3.65' />
          <polygon className='set-default-fill' points='19.15 8 16.7 13.62 19.05 12.33 21.34 13.73 19.15 8' />
        </g>
      </g>
    </g>
  </Box>
)

export default SetDefault
